import { EditOutlined, EyeOutlined, MoreOutlined, RollbackOutlined } from "@ant-design/icons";
import { Badge, Dropdown, Space } from "antd";
import TableAntd from "components/elements/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useSelector } from "react-redux";

const ExpenseTableList = ({
    dataSource = [],
    handleView = () => { },
    pagination = {},
    onPageChange = () => { },
    handleEdit = () => { },
    isEmployee = false,
    onRejectExpense = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const { roles } = useSelector((state) => state.company);

    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
    }

    const columns = [
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("expense.expense-detail.request-id")}</div>,
            dataIndex: "sequence",
            key: "sequence",
            render: (_, record) => (
                <Badge count={record.sequence} style={{ backgroundColor: "#F5F6F7", color: "#313131" }} />
            ),
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("expense.create-date")}</div>,
            dataIndex: "createDate",
            key: "createDate",
            render: (_, record) => record?.createDate ? formatDate(record?.createDate) : "-",
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("holiday.label.start_date")}</div>,
            dataIndex: "startDate",
            key: "startDate",
            render: (_, record) => record?.startDate ? formatDate(record?.startDate) : "-",
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("holiday.label.end_date")}</div>,
            dataIndex: "endDate",
            key: "endDate",
            render: (_, record) => record?.endDate ? formatDate(record?.endDate) : "-",
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("welfare.label.name")}</div>,
            dataIndex: "welfareName",
            key: "welfareName",
            render: (_, record) => {
                return i18n.language === 'en' ? record?.welfareDetails?.welfareNameEn : record?.welfareDetails?.welfareName
            }
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("expense.header")}</div>,
            dataIndex: "expense",
            key: "expense",
            render: (_, record) => {
                return i18n.language === 'en' ? record?.welfareSubCategoryType?.nameEn : record?.welfareSubCategoryType?.name
            }
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("expense.amount")}</div>,
            dataIndex: "totalExpense",
            key: "totalExpense",
            align: "right",
            render: (_, record) => record?.totalExpense ? get2DecimalPointsWithCommas(record?.totalExpense) : "-"

        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("expense.description")}</div>,
            dataIndex: "description",
            key: "description"
        },
        {
            title: <div className="text-table" style={{ color: "#667085" }}>{t("expense.status")}</div>,
            dataIndex: "approveStatus",
            key: "approveStatus",
            render: (_, record) => {
                const statusText = i18n.language === 'en' ? record.approveStatusEn : record.approveStatus;
                return statusText ? (
                    <StatusTag value={statusText} text={statusText} />
                ) : "-";
            },
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: "100px",
            render: (_, record) => {
                const isApproved = record.approveStatusEn === "Approved" || record.approveStatusEn === "Pending" || record.approveStatusEn === "Rejected";
                const menuItems = [
                    {
                        key: "1",
                        onClick: () => handleView(record),
                        label: <p style={{ color: "grey", fontSize: "14px" }}>{t("action.view")}</p>,
                        icon: <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />,
                    },
                ];

                if (!isApproved && roles.includes("UPDATE_EXPENSE|HOME") && !isEmployee) {
                    menuItems.push({
                        key: "2",
                        onClick: () => handleEdit(record),
                        label: <p style={{ color: "grey", fontSize: "14px" }}>{t("action.edit")}</p>,
                        icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
                    });
                }
                if (record.approveStatusEn === "Approved" && roles.includes("UPDATE_EXPENSE|HOME")) {
                    menuItems.push({
                        key: "3",
                        onClick: () => handleView(record, "reject"),
                        label: <p style={{ color: "grey", fontSize: "14px" }}>{t("common.reject")}</p>,
                        icon: (
                            <RollbackOutlined style={{ fontSize: "18px", color: "gray" }} />
                        ),
                    });
                }

                return (
                    <Space size="middle" >
                        <Dropdown placement="bottomRight" menu={{ items: menuItems }}>
                            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                        </Dropdown>
                    </Space >
                );
            },
        },
    ];

    return (
        <TableAntd
            columns={columns}
            dataSource={dataSource}
            onChange={onPageChange}
            pagination={{
                ...pagination
            }}
        />
    )
}

export default ExpenseTableList;